import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: { main: "#18AEAC" },
    secondary: { main: "#074974" },
    background: {
      default: "#f8fafb",
    },
    text: {
      secondary: "#4b5b63",
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 500, lineHeight: 1.6 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // Preserve the browser's default body margin, which CssBaseline
        // otherwise resets to 0, so introducing CssBaseline doesn't change
        // the rendered layout.
        body: {
          margin: "8px",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: "0 2px 16px rgba(7, 73, 116, 0.08)",
        },
      },
    },
  },
});

// One-off section background tints that aren't reused elsewhere, so they
// aren't worth adding to the MUI palette type via module augmentation.
export const sectionColors = {
  contactBackground: "#f0f4f6",
  infoBackground: "#dde9f5",
};
